<template>
  <div class="container mescroll-touch">
    <div class="header">
      <!-- <img class="bg" src="@/assets/images/bg_comm_png@2x.png" /> -->
      <div class="bgBox"></div>
      <img class="logo" src="@/assets/images/logo.jpg" />
    </div>
    <div class="content">
      <p class="title">
        <template v-if="userInfo.Type != 3">选择您更多感兴趣的领域，将会为您推荐相关内容<span>（选填）</span></template>
        <template v-if="userInfo.Type == 3">Choose more interests for personalized recommendations<span>(Optional)</span></template>
      </p>
      <p class="total"><span>{{num}}</span>/{{total}}</p>
      <div class="line"></div>
      <div class="departmentList">
        <div class="block" :class="{'active': item.isChecked == true}" v-for="(item, index) in list" :key="index" @click="selectItem(index)">
          <div class="department">
            <img v-if="item.Code == 'puwaike' || item.Code == 'GS'" class="department_icon" src="@/assets/images/department_icon2.png" />
            <img v-if="item.Code == 'xinwaike' || item.Code == 'CV'" class="department_icon" src="@/assets/images/department_icon4.png" />
            <img v-if="item.Code == 'guke' || item.Code == 'Ortho'" class="department_icon" src="@/assets/images/department_icon1.png" />
            <img v-if="item.Code == 'fuchanke' || item.Code == 'OB/GYN'" class="department_icon" src="@/assets/images/department_icon5.png" />
            <img v-if="item.Code == 'miniaoke' || item.Code == 'Uro.'" class="department_icon" src="@/assets/images/department_icon6.png" />
            <img v-if="item.Code == 'xiongwaike' || item.Code == 'Thor'" class="department_icon" src="@/assets/images/department_icon7.png" />
            <img v-if="item.Code == 'shenwaike' || item.Code == 'Neuro.'" class="department_icon" src="@/assets/images/department_icon8.png" />
            <span>{{item.Name}}</span>
          </div>
        </div>
      </div>
      <div class="handle">
        <div class="btn reset" @click="reset">
          <template v-if="userInfo.Type != 3">重置</template>
          <template v-if="userInfo.Type == 3">Reset</template>
        </div>
        <div class="btn confirm" @click="confirm">
          <template v-if="userInfo.Type != 3">确认</template>
          <template v-if="userInfo.Type == 3">Confirm</template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AreaOfInterest',
  data() {
    return {
      list: [],
      checkedList: [],
      num: 0,
      total: 0
    }
  },
  computed: {
    ...mapState(['userInfo']),
    uri() {
      return this.$route.query.uri;
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      let fullPath = from.fullPath;
      let index = fullPath.indexOf("stack-key");
      if(index == -1) {
        vm.hasPath = fullPath;
      } else {
        vm.hasPath = fullPath.slice(0, index-1) + fullPath.slice(index + 18);
      }
    });
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      const type = this.userInfo.Type != 3 ? 1 : 2;
      this.$axios.get('/Api/Api/Web/Customer/GetDitWebCodeList?type=' + type).then(res => {
        this.list = res.Data;
        this.total = this.list.length;
        this.getCheckedList();
      })
    },
    getCheckedList() {
      this.$axios.post('/Api/Api/Web/Customer/GetInteresteds?CustomerId=' + this.userInfo.Id).then(res => {
        this.checkedList = res.Data; 
        this.list.forEach(item => {
          this.checkedList.forEach(checkedItem => {
            if (item.Code == checkedItem.SubPCode) {
              item.isChecked = true;
            }
          })
        })
        this.getCheckedNum();
        this.$forceUpdate();
      })
    },
    selectItem(index) {
      this.list[index].isChecked = !this.list[index].isChecked;
      this.getCheckedNum();
      this.$forceUpdate();
    },
    getCheckedNum() {
      this.num = 0;
      this.list.forEach(item => {
        if (item.isChecked) {
          this.num++;
        }
      })
    },
    confirm() {
      let checkedList = [];
      this.list.forEach(item => {
        if(item.isChecked) {
          checkedList.push({
            SubId: item.Id,
            SubPCode: item.Code
          })
        }
      });
      
      this.$axios.post('/Api/Api/Web/Customer/AddInterested', {
        CustomerId: this.userInfo.Id,
        aInte: checkedList
      }).then(() => {
        this.$router.push(this.hasPath);
      })
    },
    reset() {
      this.$axios.post('/Api/Api/Web/Customer/delInterested?CustomerId=' + this.userInfo.Id).then(() => {
        this.$toast.success('重置成功');
        this.getList();
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  font-family: PingFangSC-Medium, sans-serif;
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
}
.header {
  position: relative;
}
.bg {
  display: block;
  width: 100%;
}
.bgBox {
  width: 100%;
  height: 122px;
  background-color: #EB1701;
}
.logo {
  position: absolute;
  display: block;
  width: 110px;
  left: 50%;
  top: 68px;
  transform: translate(-50%, 0);
}
.content {
  margin-top: 60px;
  padding: 20px 30px;
}
.title {
  font-size: 16px;
  font-weight: bold;
  color: #564C47;
  span {
    color: #CA001A;
  }
}
.total {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #564C47;
  margin: 10px 0;
  span {
    color: #CA001A;
  }
}
.line {
  height: 1px;
  background: linear-gradient(to right, #EB1700 0%, #C33BBB 60%, #8C3BBB 100%);
}
.departmentList {
  display: flex;
  flex-wrap: wrap;
  margin-top: 19px;
  margin-bottom: 60px;
}
.block {
  margin-bottom: 16px;
  width: calc(calc(100% / 2) - 8px);
  height: 45px;
  border-radius: 45px;
  background-color: #F2F2F2;
  padding: 1px;
  box-sizing: border-box;
  .department {
    height: 100%;
    border-radius: 43px;
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #CA001A;
    font-weight: bold;
    padding: 0 10px;
    .department_icon {
      display: block;
      width: 30px;
      margin-right: 12px;
    }
  }
}
.block:nth-child(odd) {
  margin-right: 15px;
}
.active {
  background: linear-gradient(to right, #EB1700 0%, #C33BBB 60%, #8C3BBB 100%);
  .department {
    background: #FFFFFF;
  }
}
.handle {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  padding: 0 15%;
  box-sizing: border-box;
  .btn {
    width: 100px;
    height: 35px;
    line-height: 35px;
    border-radius: 35px;
    text-align: center;
    font-size: 15px;
  }
  .reset {
    color: #CA001A;
    background-image: url('../../assets/images/btn_bg2.png');
    background-size: 100% 100%;
  }
  .confirm {
    color: #FFFFFF;
    background-image: url('../../assets/images/btn_bg1.png');
    background-size: 100% 100%;
  }
}
</style>